/* import __COLOCATED_TEMPLATE__ from './feedback.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { waitForPromise } from '@ember/test-waiters';
import { htmlSafe } from '@ember/template';

import Constants from '../../utils/constants';

export default class FeedbackModal extends Component {
  @service intl;

  modalId = 'feedback-modal';

  get modalType() {
    return Constants.MODAL_TYPES.FEEDBACK.value;
  }

  @action sendFeedback(feedbackInfo) {
    this.args.model.markAsNotReady();

    this.deliverFeedback(feedbackInfo.name, feedbackInfo.email, feedbackInfo.feedback).then((result) => {
      this.args.model.markAsReady();
      if (result.status !== 0) {
        let modalData = {
          text: htmlSafe(this.intl.t(`labels.modal.feedback.error-message`)),
          title: htmlSafe(this.intl.t(`labels.modal.feedback.title`)),
        };
        this.args.model.modalHandler.show(Constants.MODAL_TYPES.HELP.value, modalData);
      }
    });
  }

  deliverFeedback(name, email, feedback) {
    const feedbackData = {
      ToolId: Constants.API_TOOL_ID,
      Name: encodeURIComponent(name),
      Email: encodeURIComponent(email),
      Feedback: encodeURIComponent(feedback),
    };
    return waitForPromise(
      fetch(this.args.model.urlHandler.feedbackUrl, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(feedbackData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error(`The feedback could not be delivered: ${error}`);
          return { status: -1 };
        }),
    );
  }
}
